import createIcon from '../../createIcon';

/**
 * @component @name Rtt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS4wMyAzTDcuOTIgMTAuMDdIMTAuNTRMMTEuMjQgNS41N0gxMy44MkwxMS44IDE4LjQzSDkuNDdMOS4wNiAyMUgxNi4zM0wxNi43MyAxOC40M0gxNC4zOEwxNi4zOCA1LjU3SDE4Ljk2TDE4LjI1IDEwLjA3SDIwLjlMMjIgM0g5LjAzWk04IDVINEwzLjY5IDdINy42OUw4IDVaTTcuMzkgOUgzLjM5TDMuMDggMTFINy4wOEw3LjM5IDlaTTguMzEgMTdIMi4zMUwyIDE5SDhMOC4zMSAxN1pNOC45MyAxM0gyLjkzTDIuNjIgMTVIOC42M0w4LjkzIDEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Rtt = createIcon('Rtt', [
  [
    'path',
    {
      d: 'M9.03 3L7.92 10.07H10.54L11.24 5.57H13.82L11.8 18.43H9.47L9.06 21H16.33L16.73 18.43H14.38L16.38 5.57H18.96L18.25 10.07H20.9L22 3H9.03ZM8 5H4L3.69 7H7.69L8 5ZM7.39 9H3.39L3.08 11H7.08L7.39 9ZM8.31 17H2.31L2 19H8L8.31 17ZM8.93 13H2.93L2.62 15H8.63L8.93 13Z',
      key: '7oas63',
    },
  ],
]);

export default Rtt;
